import React from "react";
import "./LoadingOverlay.css";

/*
 * Full-screen blocking spinner shown while something slow is in flight.
 *
 * This was inline-styled and copy-pasted into five components
 * (start-assessment, Interventions, Review-assessment, summarypage,
 * goalsetdownload) purely for "Generating PDF, please wait...". That duplication
 * is why the wording, colours and spinner geometry had already drifted apart, and
 * why the page-navigation case had no spinner at all - clicking "Review Assessment"
 * in goalreview.js jumped straight to /start-assessment with a blank white frame
 * while the pathway loaded.
 *
 * One component, one look, every caller.
 *
 * `message` defaults to the PDF copy so the five existing call sites can migrate
 * without changing behaviour; navigation callers pass their own text.
 */
export default function LoadingOverlay({ message = "Generating PDF, please wait..." }) {
    return (
        <div className="loading-overlay" role="status" aria-live="polite" data-testid="loading-overlay">
            <div className="loading-overlay-spinner" aria-hidden="true" />
            <p className="loading-overlay-text">{message}</p>
        </div>
    );
}
